import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useImgUpload } from "../../api/file";
import useNotice from "../../hooks/useNotice";

function UploadImg({
  size,
  label = "上传图片",
  maxLength = 3,
  multiple = true,
  onSuccess,
  fileList
}) {
  const { uploadHandle } = useImgUpload();
  const { t } = useTranslation();
  const notice = useNotice();
  const [uploadResult, setUploadResult] = useState([]);

  const upload = (e) => {
    let files = e.target.files;
    let filesMaps = [...files];

    if (files.length > maxLength) {
      notice.warn(`最多上传${maxLength}张图片`);
      filesMaps = filesMaps.slice(0, maxLength);
    }

    filesMaps.forEach(async (file) => {
      let q = {
        btype: "comment",
        file,
      };
      console.log(file, "file");
      const res = await uploadHandle(q);
      if (res.code === 0) {
        setUploadResult(uploadResult.concat(res.data.fileUrlView));
      }
    });
  };
  

  useEffect(() => {
    onSuccess(uploadResult)
  },[uploadResult])

  useEffect(() => {
    fileList && setUploadResult(fileList)
  },[fileList])


  const closeImg = () => {
    setUploadResult([])
  }

  return (
    <div className="border-dashed border-[2px] rounded-[5px] w-[180px] h-[180px] flex justify-center items-center border-[#d4d4d4] relative">
      {uploadResult.length ? (
        <div className="w-[100%] h-[100%] relative">
          <img
            src={uploadResult[0]}
            alt=""
            className="w-[100%] h-[100%]"
          />
          <div className=" absolute top-[3px] right-[10px]" onClick={closeImg}>
            <i
              className={
                "iconfont icon-delete text-2xl cursor-pointer"
              }
            ></i>
          </div>
        </div>
      ) : (
        <label className="block text-center mt-[12px] cursor-pointer">
          <i className="iconfont icon-plus text-[#999] text-[24px]"></i>
          <p className="text-[#999] text-[13px]">{t(label)}</p>

          <input
            type="file"
            onChange={upload}
            multiple={multiple}
            style={{ height: 1, visibility: "hidden" }}
          />
        </label>
      )}
    </div>
  );
}

export default memo(UploadImg);
